import React from "react";
import styled from "styled-components";
import { sharedLib } from "@shared/services/shared.service";
import { DISPLAY_CURRENCIES } from "@shared/common/constants";
import LiveSymbolAvgPrice from "common/LiveComponents/LiveSymbolAvgPrice";
import LiveAvgPriceChange from "common/LiveComponents/LiveAvgPriceChange";
import useHistoryWithQuery from "utils/hooks/useHistoryWithQuery";
import { getCoinExtraDetailsRoute } from "utils/routes";
import { HEADER_BTC_TICKER_ID } from "testIds";

const HeaderBtcTicker = () => {
  const { historyPush } = useHistoryWithQuery();
  const { data, fulfilledTimeStamp } =
    sharedLib.sharedApi.dashboard.useGetDashboardDataQuery();
  const btcSummary = data?.asset_summary?.[BTC]?.[DISPLAY_CURRENCIES.USD];

  if (!btcSummary) return null;

  const openBtcDetails = () => {
    historyPush(getCoinExtraDetailsRoute(location.pathname, BTC));
  };

  return (
    <Ticker data-testid={HEADER_BTC_TICKER_ID} onClick={openBtcDetails}>
      <Label>
        {BTC}
        <LiveAvgPriceChange
          symbol={BTC}
          initialChange={btcSummary[2] / 100}
          initialChangeTimestamp={fulfilledTimeStamp}
          currency={DISPLAY_CURRENCIES.USD}
          hideBackground={true}
          style={CHANGE_STYLE}
          textStyle={CHANGE_TEXT_STYLE}
        />
      </Label>
      <Price>
        <LiveSymbolAvgPrice
          symbol={BTC}
          initialPrice={btcSummary[0]}
          initialPriceTimestamp={fulfilledTimeStamp}
          currency={DISPLAY_CURRENCIES.USD}
          precision={0}
          fontSize={14}
          iconStyle={PRICE_ICON_STYLE}
        />
      </Price>
    </Ticker>
  );
};

export default React.memo(HeaderBtcTicker);

const BTC = "BTC";
const CHANGE_STYLE = { marginLeft: 4, fontSize: 11 };
const CHANGE_TEXT_STYLE = { fontSize: 11, fontWeight: 500 };
const PRICE_ICON_STYLE = { marginRight: 1 };

const Ticker = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 1px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
`;
const Label = styled.span`
  display: flex;
  align-items: center;
  font-size: 11px;
  line-height: 14px;
  color: ${(p) => p.theme.colors.secondaryText};
`;
const Price = styled.span`
  line-height: 18px;
  font-weight: ${(p) => p.theme.typography.fontWeights.SEMI_BOLD};
  color: ${(p) => p.theme.colors.titleColor};
`;
